/**
 * Register page UI text translations
 * These are display labels, NOT secrets or API keys
 */
export const registerTranslations = {
  en: {
    title: 'Create Account',
    subtitle: 'Join English Passion and start your learning journey',
    nameLabel: 'Full Name',
    emailLabel: 'Email Address',
    passwordLabel: 'Password',
    phoneLabel: 'Phone Number (Optional)',
    roleLabel: 'I am a',
    studentRole: 'Student',
    studentDescription: 'I want to learn English',
    teacherRole: 'Teacher',
    teacherDescription: 'I want to teach English',
    createButton: 'Create Account',
    creatingButton: 'Creating...',
    hasAccountText: 'Already have an account?',
    signInLink: 'Sign In',
    passwordRequirement: 'At least 8 characters'
  },
  ko: {
    title: '계정 만들기',
    subtitle: 'English Passion에 가입하고 학습 여정을 시작하세요',
    nameLabel: '이름',
    emailLabel: '이메일 주소',
    passwordLabel: '비밀번호',
    phoneLabel: '전화번호 (선택)',
    roleLabel: '저는',
    studentRole: '학생',
    studentDescription: '영어를 배우고 싶어요',
    teacherRole: '선생님',
    teacherDescription: '영어를 가르치고 싶어요',
    createButton: '계정 만들기',
    creatingButton: '생성 중...',
    hasAccountText: '이미 계정이 있으신가요?',
    signInLink: '로그인',
    passwordRequirement: '8자 이상'
  },
  ja: {
    title: 'アカウント作成',
    subtitle: 'English Passionに参加して学習の旅を始めましょう',
    nameLabel: '氏名',
    emailLabel: 'メールアドレス',
    passwordLabel: 'パスワード',
    phoneLabel: '電話番号（任意）',
    roleLabel: '私は',
    studentRole: '生徒',
    studentDescription: '英語を学びたい',
    teacherRole: '講師',
    teacherDescription: '英語を教えたい',
    createButton: 'アカウント作成',
    creatingButton: '作成中...',
    hasAccountText: 'すでにアカウントをお持ちですか？',
    signInLink: 'サインイン',
    passwordRequirement: '8文字以上'
  }
};
